import React from 'react';
import { connect } from 'react-redux';
import { setDialInState } from '../actions';

class DialIn extends React.Component {

	constructor( props ) {
		super( props );
		this.state = { dial_in_state: [] };
	}

	get_phone_numbers( phone_numbers_info ) {
		const phone_numbers = phone_numbers_info.phone_numbers;
		const dial_in_code = (typeof phone_numbers_info.dial_in_code !== 'undefined'
		                     ) ? phone_numbers_info.dial_in_code : false;
		const phoneHTML = phone_numbers.map( ( dial_info ) => (<tr>
				<td>{ dial_info[ 0 ] }</td>
				<td>{ dial_info[ 1 ] }</td>
			</tr>
		) );

		if ( dial_in_code !== false ) {
			phoneHTML.push( <tr>
				<td>Conference Code:</td>
				<td>{ dial_in_code }</td>
			</tr> );
		}
		return phoneHTML;
	}

	isEmpty( obj ) {
		return !obj || Object.keys( obj ).length === 0;
	}

	show_dial_in( remove = false ) {
		const meet_id = this.props.meet_id;
		const newState = this.state.dial_in_state;
		if ( remove === true ) {
			let index = newState.indexOf( this.props.meet_id );
			if ( index > -1 ) {
				newState.splice( index, 1 );
			}
		} else {
			newState.push( meet_id );
		}
		this.setState( { dial_in_state: newState } );

	}

	render() {
		if ( this.props.type === 'past' ) {
			return (<div></div>
			);
		}
		if ( !this.isEmpty( this.props.info ) ) {
			let phoneNumbersHtml = this.get_phone_numbers( this.props.info );
			return (
				<div className={ 'dial-in-table-container' }>
					<table className={ 'dial-in-table' }>
						{ phoneNumbersHtml }
					</table>
				</div>
			);
		} else {

			return (
				<div className={ 'dial-in-section download-list-item' }>
					<div className="agenda-dropdown no-agenda not-available">No Dial-in Information</div>
				</div>
			);
		}

	}

}

function mapStateToProps( { agendaStatus, dialInStatus } ) {
	return { agendaStatus, dialInStatus };
}

export default connect( mapStateToProps, {} )( DialIn );
